import { theme } from '~/theme';

export const useSxStyles = () => {
  return {
    formContentRow: {
      display: 'flex',
      alignItems: 'baseline',
    },
    twoFieldRow: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gridColumnGap: theme.spacing(1),
    },
  };
};
